import { render, staticRenderFns } from "./DatePickerSmall.vue?vue&type=template&id=22d7385d"
import script from "./DatePickerSmall.vue?vue&type=script&lang=js"
export * from "./DatePickerSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports